import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options", "onChange", "value"];
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSelect = styled.select.withConfig({
  displayName: "Select__StyledSelect"
})(({
  theme
}) => ({
  backgroundColor: theme.color['fill-transparent-default'],
  fontFamily: theme.typography['body-125'].fontFamily,
  border: 'none',
  appearance: 'none',
  color: theme.color['text-interactive-default'],
  fontSize: theme.typography['body-125'].fontSize,
  fontWeight: theme.typography['body-125'].fontWeight,
  textAlignLast: 'center',
  paddingLeft: theme.space[100],
  WebkitFontSmoothing: 'antialiased',
  cursor: 'pointer',
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  opacity: 0
}));
const StyledLabel = styled.div.withConfig({
  displayName: "Select__StyledLabel"
})(({
  theme
}) => ({
  color: theme.color['text-interactive-default'],
  fontSize: theme.typography['body-125'].fontSize,
  fontWeight: theme.typography['body-125'].fontWeight,
  fontFamily: theme.typography['body-125'].fontFamily,
  paddingLeft: theme.space[100],
  pointerEvents: 'none'
}));
const StyledCaret = styled.div.withConfig({
  displayName: "Select__StyledCaret"
})(({
  theme
}) => ({
  color: theme.color['icon-core-subtle'],
  marginLeft: theme.space[200],
  borderStyle: 'solid',
  borderWidth: '6px',
  borderColor: 'transparent',
  display: 'inline-block',
  verticalAlign: 'middle',
  borderTopColor: 'currentColor',
  marginTop: theme.space[100],
  alignSelf: 'center',
  flexShrink: 0,
  pointerEvents: 'none'
}));
const StyledSelectWrapper = styled.div.withConfig({
  displayName: "Select__StyledSelectWrapper"
})(({
  theme
}) => ({
  marginLeft: theme.space[200],
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  '&:hover div': {
    textDecoration: 'underline'
  }
}));
const Select = _ref => {
  var _options$;
  let {
      options,
      onChange,
      value
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const onHandleChange = event => {
    onChange(event.target.value);
  };
  const selectedOption = options.find(opt => opt.value === value);
  const selectedLabel = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || ((_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.label) || '';
  return /*#__PURE__*/_jsxs(StyledSelectWrapper, {
    children: [/*#__PURE__*/_jsx(StyledSelect, Object.assign({}, props, {
      onChange: onHandleChange,
      value: value,
      children: options.map(({
        label,
        value: optionValue
      }) => /*#__PURE__*/_jsx("option", {
        value: optionValue,
        children: label
      }, optionValue))
    })), /*#__PURE__*/_jsx(StyledLabel, {
      "data-test-id": "select-label",
      children: selectedLabel
    }), /*#__PURE__*/_jsx(StyledCaret, {})]
  });
};
export default Select;